// IMPORTANT: Must stay in sync with COLLECTION_MANIFEST / COPY_MANIFEST in
// apps/rest_server/business-logic/account-migration.js
export const COLLECTION_CATEGORIES = {
  'Structural': {
    label: 'Structural Assets',
    description: 'Sensors, streams, transmitters, sites, locations',
    collections: ['sensors', 'streams', 'transmitters', 'sites', 'locations', 'sensorgroups', 'sensortypes', 'sims'],
  },
  'Users & Permissions': {
    label: 'Users & Permissions',
    description: 'Users, user groups',
    collections: ['users', 'usergroups'],
  },
  'Rules & Notifications': {
    label: 'Rules & Notifications',
    description: 'Rule groups, notification protocols, predefined notes',
    collections: ['rulegroups', 'notificationprotocols', 'predefinednotes'],
  },
  'Financial': {
    label: 'Financial',
    description: 'Contracts, invoices, quotes, subscriptions, projects',
    collections: ['contracts', 'invoices', 'quotes', 'subscriptions', 'projects'],
  },
  'Alerts & Tickets': {
    label: 'Alerts & Tickets',
    description: 'Alert histories, sendouts, tickets',
    collections: ['alerthistories', 'alertsendouts', 'tickets'],
  },
  'Reports & Documents': {
    label: 'Reports & Documents',
    description: 'Reports, calibration records',
    collections: ['reports', 'calibrationrecords'],
  },
  'Activity': {
    label: 'Activity Logs',
    description: 'Change logs, events',
    collections: ['changelogs', 'events'],
  },
} as const;

export const COPY_COLLECTION_CATEGORIES = {
  'Structural': {
    label: 'Structural Assets',
    description: 'Sensors, streams, transmitters, sites, locations',
    collections: ['sensors', 'streams', 'transmitters', 'sites', 'locations', 'sensorgroups', 'sensortypes'],
  },
  'Permissions': {
    label: 'Permissions',
    description: 'User groups',
    collections: ['usergroups'],
  },
  'Rules & Notifications': {
    label: 'Rules & Notifications',
    description: 'Rule groups, notification protocols, predefined notes',
    collections: ['rulegroups', 'notificationprotocols', 'predefinednotes'],
  },
} as const;

export const COLLECTION_LABELS: Record<string, string> = {
  sensors: 'Sensors',
  streams: 'Streams',
  transmitters: 'Transmitters',
  sites: 'Sites',
  locations: 'Locations',
  sensorgroups: 'Sensor Groups',
  sensortypes: 'Sensor Types',
  sims: 'SIM Cards',
  users: 'Users',
  usergroups: 'User Groups',
  rulegroups: 'Rule Groups',
  notificationprotocols: 'Notification Protocols',
  predefinednotes: 'Predefined Notes',
  contracts: 'Contracts',
  invoices: 'Invoices',
  quotes: 'Quotes',
  subscriptions: 'Subscriptions',
  projects: 'Projects',
  alerthistories: 'Alert History',
  alertsendouts: 'Alert Sendouts',
  tickets: 'Tickets',
  reports: 'Reports',
  calibrationrecords: 'Calibration Records',
  changelogs: 'Change Logs',
  events: 'Events',
};
